<template>
  <div class="company-optionA">
    <div class="left">
      <div>
        <p style="color: #000; text-align: center; margin: 4px;">{{ companyTips }}</p>
      </div>
      <div>
        <select v-if="fileTypeList.length > 1" size="medium" v-model="fileType">
          <option v-for="(item, index) in fileTypeList" :key="index" :label="item" :value="item"></option>
        </select>
      </div>
      <div class="upload-main">
        <div class="el-upload el-upload--text" @dragover="fileDragover" @drop="fileDrop">
          <div class="el-upload-dragger">
            <template v-if="!fileName">
              <label for="fileInput"><i class="el-icon-upload"></i></label>
            </template>
            <template v-else>
              <span class="file-name">{{fileName}}</span>
            </template>
            <label class="el-upload__text" for="fileInput">
              将附件拖到此处，或
              <br>
              <em>点击选择</em>
              <br>
              <!-- <span style="font-size: 12px;">excel\word\zip\pdf格式</span> -->
            </label>
          </div>
          <input
            id="fileInput"
            type="file"
            name="file"
            :accept="acceptList"
            @change="chooseUploadFile"
            class="el-upload__input">
        </div>
      </div>
      <div class="upload-action">
        <el-button type="primary" @click="closeIt" size="mini">{{'关闭'}}</el-button>
        <el-button type="primary" @click="upload" size="mini">{{btnName || '上传'}}</el-button>
      </div>
      <uploadFilePage :percent="percent" @cancel="handleCancel"></uploadFilePage>
    </div>
    <nut-dialog
      class="nut-dialog-fileUpLoad"
      @close="jindu = false"
      v-if="jindu"
      :closeOnClickModal="false"
      :visible="jindu"
      :title="`上传进度${percentage}%`"
      :noFooter="false"
      :noOkBtn="true"
      :noCancelBtn="true"
      :onOkBtn="onOkBtn"
      :onCancelBtn="onCancelBtn"
      cancelBtnTxt="关闭此窗口">
      <progress :value="percentage" max="100"></progress>
      <p>{{ text1 }}</p>
      <!-- <progress v-if="jiexiFlsg" :value="percentageA" max="100"></progress><span v-if="jiexiFlsg">{{ percentageA }}%</span>
      <p>{{ text2 }}</p> -->
    </nut-dialog>
  </div>
</template>

<script>
import api from '../../api/index'
import uploadFilePage from '../pages/uploadFilePage'
import axios from 'axios'
export default {
  props: ['uploadMethod', 'btnName', 'acceptList', 'extaParam', 'fileSize', 'overSizeTip'],
  data () {
    return {
      fileName: '',
      percent: 0,
      jindu: false,
      percentage: 0,
      percentageA: 0,
      text1: '',
      text2: '',
      jiexiFlsg: false,
      companyName: '',
      companyTips: '',
      // fileList: []
      fileList: [{
        id: 0,
        name: '文件名称',
        url: ''
      }, {
        id: 0,
        name: '文件名称',
        url: ''
      }, {
        id: 0,
        name: '文件名称',
        url: ''
      }, {
        id: 0,
        name: '文件名称',
        url: ''
      }, {
        id: 0,
        name: '文件名称',
        url: ''
      }, {
        id: 0,
        name: '文件名称',
        url: ''
      }, {
        id: 0,
        name: '文件名称',
        url: ''
      }, {
        id: 0,
        name: '文件名称',
        url: ''
      }, {
        id: 0,
        name: '文件名称',
        url: ''
      }, {
        id: 0,
        name: '文件名称',
        url: ''
      }, {
        id: 0,
        name: '文件名称',
        url: ''
      }, {
        id: 0,
        name: '文件名称',
        url: ''
      }, {
        id: 0,
        name: '文件名称',
        url: ''
      }],
      fileType: '环评',
      fileTypeList: ['环评', '验收'],
      documentChoose: '检查初审'
    }
  },
  mounted () {
    api.remarks({
      type: 240
    }).then(res => {
      this.companyTips = res.data.list[0].other
    })
  },
  methods: {
    // 拖拽上传
    fileDragover (e) {
      e.preventDefault()
    },
    fileDrop (e) {
      e.preventDefault()
      const file = e.dataTransfer.files[0] // 获取到第一个上传的文件对象
      if (!file) return
      if (file.size > ((this.fileSize || 10) * 1000 * 1000)) {
        this.$toast.text('文件大小不能超过' + (this.fileSize || 10) + 'M' + (this.overSizeTip || ''))
        return
      }
      this.batchFile = file
      this.fileName = file.name
    },
    chooseUploadFile (e) {
      const file = e.target.files[0]
      if (!file) return
      if (file.size > ((this.fileSize || 10) * 1000 * 1000)) {
        this.$toast.text('文件大小不能超过' + (this.fileSize || 10) + 'M' + (this.overSizeTip || ''))
        return
      }
      this.batchFile = file
      this.fileName = file.name
      e.target.value = ''
    },
    upload () {
      if (!this.fileName) {
        this.$toast.text('请选择上传文件')
        return
      }
      this.$emit('beforeUpload')
    },
    closeIt () {
      this.$emit('closeIF')
    },
    doUpload () {
      this.jiexiFlsg = false
      this.text1 = ''
      this.text2 = ''
      // var idJ = 0
      this.percentage = 0
      this.percentageA = 0
      this.jindu = true
      var bianliang = setInterval(() => {
        this.percentage = this.percentage + 1
        if (this.percentage >= 98) {
          clearInterval(bianliang)
        }
      }, 1000)
      console.log(this.extaParam, 'extaParam')
      console.log(this.uploadMethod, 'uploadMethod')
      this.CancelToken = axios.CancelToken
      this.source = this.CancelToken.source()
      // this.loading = this.$loading()
      api[this.uploadMethod](Object.assign({}, {
        multipartFile: this.batchFile,
        fileType: this.fileType
      }, this.extaParam), (percent) => {
        this.percent = percent
      }, this.source.token).then(res => {
        // this.loading && this.loading.close()
        if (res.code === 200) {
          setTimeout(() => {
            this.percentage = 100
            clearInterval(bianliang)
            this.text1 = res.message
            setTimeout(() => {
              this.jindu = false
            }, 1000)
            this.$emit('uploadSuccess', res.data)
          }, 1000)
          // idJ = res.data
          this.percentageA = 0
        } else {
          this.$toast.text(res.message || '上传失败')
          clearInterval(bianliang)
          setTimeout(() => {
            this.jindu = false
          }, 1000)
        }
      })
    },
    onCancelBtn () {
      this.jindu = false
    },
    onOkBtn () {
      this.$toast.text('请等待上传结束哦！')
    },
    handleCancel () {
      setTimeout(() => {
        this.percent = 0
      }, 100)
      this.source.cancel('Operation canceled by the user.')
    }
  },
  components: {
    uploadFilePage
  }
}
</script>

<style lang="scss">
.company-optionA {
  width: 100%;
  display: flex;
  // height: 300px;
  .left {
    width: 100%;
    margin-right: 8px;
    .upload-main {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .el-upload--text {
        text-align: center;
        width: 140px;
      }
      .el-upload-right {
        flex: 0;
        .el-form-item {
          margin-bottom: 0;
        }
        .el-cascader {
          margin-bottom: 0!important;
        }
        .el-form-item__error {
          padding-top: 0;
          top: 40px;
        }
        .el-date-editor.el-input {
          width: 172px;
          margin-bottom: 12px;
        }
        .el-select, .el-cascader {
          margin-bottom: 12px;
        }
      }
      .el-upload-dragger {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 140px;
        height: 140px;
      }
      .el-icon-upload {
        margin: 0;
      }
      label {
        display: block;
      }
    }
    .upload-action {
      margin-top: 20px;
      text-align: center;
    }
  }
  .right {
    width: calc(100% - 300px);
    margin-left: 8px;
    height: 100%;
    overflow: auto;
    .tableFileCell{
      text-decoration: underline;
      color: #00C;
    }
    .tableFileCell:hover{
      color: #66F;
      text-decoration: none;
    }
    .cell{
      border: 1px #ccc solid;
      text-align: center;
    }
    .thtitle{
      background-color: #fafafa;
      line-height: 24px;
    }
    .tdcell{
      background-color: #fff;
      line-height: 32px;
      padding: 2px;
      .el-input__inner{
        height: 28px!important;
      }
      u {
        color: #00C;
      }
    }
  }
  .nut-dialog .nut-dialog-fileUpLoad {
    width: 240px;
  }
}
</style>
